
import axios, { InternalAxiosRequestConfig } from "axios";

interface CustomHeaders {
    [key: string]: string;
}

const getTokenDataFromLocalStorage = (): { token: string | null; } => {
    if (typeof window === 'undefined') return { token: null };

    const persistRoot = localStorage.getItem('persist:root');
    if (!persistRoot) return { token: null };

    try {
        const parsedRootStorage = JSON.parse(persistRoot);
        const tokenData = parsedRootStorage.tokenData ? JSON.parse(parsedRootStorage.tokenData) : null;

        return {
            token: tokenData ? tokenData.token : null,
        };
    } catch (error) {
        return { token: null };
    }
};

const { token } = getTokenDataFromLocalStorage();

const httpClient = axios.create({
    headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
});

export const setInterceptors = (
    customHeaders: CustomHeaders = {}
) => {
    httpClient.interceptors.request.use(
        async (config: InternalAxiosRequestConfig) => {
            config.headers = {
                ...config.headers,
                ...customHeaders,
            } as InternalAxiosRequestConfig["headers"];
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
};

export default httpClient;